import Api from 'libs/api/index';

class ClickCollectApi extends Api {
  constructor() {
    super('admin/click_collect/');
  }

  redirectToShoppingCenter(id) {
    const params = { shopping_center_id: id };
    return this.buildQuery(
      'post',
      {
        params,
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      },
      'auth',
    );
  }
}

export default ClickCollectApi;
